import React, {useState,useEffect} from 'react'

import {defaultOtp, IOtp} from './Verifymobile/VerifymobileModel'

import companyLogo from './Avision_Logo.png';
import {
  ref,
  onValue,
  push,
  update,
  remove
} from 'firebase/database';
import axios from 'axios';
import {Routes, Route, useNavigate} from 'react-router-dom';
import Popup from './../Popup';
import './../style.css';
import CountdownTimer from './otpexpiry/CountdownTimer';
import successlogo from './correct.png';
import failedlogo from './failed.png';
import loadingicon from './load-icon.png';
import {getStorage, ref as ref_storage, getDownloadURL ,listAll} from "firebase/storage";
import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  setDoc ,
} from "firebase/firestore";
import {db, storage} from './../firebase';
import Swal from 'sweetalert2'
import { OTPINSERT_LOG_TYPE } from '../../models/common/common';

export function OtpVerify() {
  const usersCollectionRef = collection(db, "Member");
  const  datetimeout = useState('');
  const [logoImageweb, setLogoImageweb] = useState('');
  const [ note, setNote ] = useState("")
  const [data, setData] = useState<IOtp>(defaultOtp)
  //const [hasError, setHasError] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [checkresend, setcheckresend] = useState(false);
  const [checkresendtime, setcheckresendtime] = useState(true);
  const [isOpenotplimit, setIsOpenotplimit] = useState(false);
  const [isOpenotpRemaining, setIsOpenotpRemaining] = useState(false);
  const [isOpenNotconnectBc, setIsOpenNotconnectBc] = useState(false);
  const [buttonState,setButtonState]=useState(false)
  const [messageRemaining, setmessageRemaining] = useState("");
  const [messagesmsotp, setmessagesmsotp] = useState("");
  const [isOpenLoading, setIsOpenLoading] = useState(false);


  const updateData = (fieldsToUpdate: Partial<IOtp>) => {
    const updatedData = {...data, ...fieldsToUpdate}
    setData(updatedData)
  }
    const navigate = useNavigate();
    const togglePopup = () => {
      setIsOpen(!isOpen);
    }
const connectionweb = JSON.parse(""+window.sessionStorage.getItem("connection"));
    // countdown
      const [ countdateTime, setcountdateTime ] = useState<number>();
      if (checkresend==false) {
          const dateTimesms = connectionweb[0].Otp_Sms_Provider_Timout;
        const THREE_DAYS_IN_MS = dateTimesms * 60 * 1000;
        const NOW_IN_MS = new Date().getTime();
        const dateTimeAfterThreeDays = NOW_IN_MS + THREE_DAYS_IN_MS;
        setcountdateTime(dateTimeAfterThreeDays);
        setcheckresend(!checkresend);

      }


    const dateTimesms = connectionweb[0].Otp_Sms_Provider_Timout * 60;

      const [counter, setCounter] = useState(dateTimesms);
      useEffect(() => {
          counter > 0 && setTimeout(() => setCounter(counter - 1), 1000);
          if (counter==0) {
            console.log("timeout");
            console.log("checkresendtime",checkresendtime);

            if (checkresendtime==true) {
              setcheckresendtime(false);
            }

          }
        //  console.log("counter",counter);

        }, [counter]);



    useEffect(() => {

      const getAllData = async () => {
        await defaultweb()
        await setfileconfig()
      //  await citystorage()
      //  await stylesweb()
        // await updatadata()
      };

      getAllData();

      // setStateCounty(ssssss)
    },[])
    const togglePopupotpRemaining = () => {
      setIsOpenotpRemaining(!isOpenotpRemaining);
    }
    const togglePopupNotconnectBc = () => {
      //setIsOpenNotconnectBc(!isOpenNotconnectBc);
    }
    function popupotplimit() {
      setIsOpenotplimit(!isOpenotplimit);
    }
    function popupotpRemaining() {
      setIsOpenotpRemaining(!isOpenotpRemaining);
    }
    function popupNotconnectBc() {
      setIsOpenNotconnectBc(!isOpenNotconnectBc);
    }
    const togglePopupLoading = () => {
      setIsOpenLoading(!isOpenLoading);
    }
    function popupLoading() {
      setIsOpenLoading(!isOpenLoading);
    }

  /*const getReturnValues = (countdateTime) => {
    // calculate time left
    const days = Math.floor(countDown / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (countDown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((countDown % (1000 * 60* 60)) / 1000);
    return [days, hours, minutes, seconds];
  };*/







  const setupwebdefault = JSON.parse(""+window.sessionStorage.getItem("setupwebdefault"));
  const storageRef_logoweb = ref_storage(storage, setupwebdefault.club_logo_path);
  getDownloadURL(storageRef_logoweb).then((url) => {
    // console.log(url);
    setLogoImageweb(url)
  });
  const [smsref, setsmsref] = useState<String>();
  const [smsphone, setsmsphone] = useState<String>();
  async function setfileconfig() {
      const setupwebdefault = JSON.parse(""+window.sessionStorage.getItem("setupwebdefault"));
      const storageRef_logoweb = ref_storage(storage, setupwebdefault.club_logo_path);
      getDownloadURL(storageRef_logoweb).then((url) => {
        // console.log(url);
        setLogoImageweb(url)
      });
  }
  async function defaultweb() {

    let otpsms = window.sessionStorage.getItem('OTPSMS');
    let otpsmsconvert= ""+otpsms;
    const objsms = JSON.parse(otpsmsconvert);
    setsmsphone(objsms.telephone);
    setsmsref(objsms.ref_code);
    setmessagesmsotp("");

  }
  function checkcluburl(url:any)
  {
      const encoded = encodeURIComponent(url);
      return  encoded;
  }


  // resend otp
    const handleClickResend = async () => {
      setOtp([...otp.map((d, idx) =>  "" )]);
      setmessagesmsotp("");
        popupLoading()

      let otpsms = window.sessionStorage.getItem('OTPSMS');
      let otpsmsconvert= ""+otpsms;
      const objsms = JSON.parse(otpsmsconvert);
      let clubcode = window.sessionStorage.getItem('Club_Code');
      let clubcodeconvert =""+clubcode;
      let linedata = window.sessionStorage.getItem('linedata');
      let linedataconvert =""+linedata;
      var urlotpUsage =connectionweb[0].BC_Api_Endpoint+connectionweb[0].BC_Api_Otp_Check_Quota_Insert_Usage;
      var myHeadersotpUsage = new Headers();
      myHeadersotpUsage.append("Authorization", authenticateUser(connectionweb[0].BC_Api_Username,connectionweb[0].BC_Api_Password));
      myHeadersotpUsage.append("Content-Type", "application/json");
      var raw = JSON.stringify({
          "clubCode": clubcodeconvert,
          "mobileNo": objsms.telephone,
          "firstName": objsms.username,
          "lastName": objsms.lastname,
          "otpType": OTPINSERT_LOG_TYPE.REGISTER_MEMBER
      });
              fetch(urlotpUsage, {
                method: 'POST',
                headers: myHeadersotpUsage,
                body: raw,
                redirect: 'follow'
              })
              .then(response => response.text())
              .then(datares => {
                console.log("data",datares);
                const otpUsage = JSON.parse(datares);
                console.log(otpUsage);
                if (!otpUsage.SystemId) {
                  setIsOpenLoading(false);
                  popupotpRemaining()
                  return ;
                }
                console.log(otpUsage.otpRemaining);

                if (otpUsage.SystemId) {
                            let notiotp =Number(connectionweb[0].Otp_Remaining_Notification) ;

                           if (otpUsage.otpRemaining == notiotp) {
                             ///send email notiotp connectionweb[0].Admin_Email_Contact_To
                             const str = new Date().toLocaleString('en-US', { timeZone: 'Asia/Jakarta' });
                             var urlsendmail =connectionweb[0].Web_Api_Endpoint+"/sendmail";
                             const resp =  axios.post(urlsendmail,{
                                 "email_from" : connectionweb[0].Admin_Email_Contact_From,
                               //  "email_to" : "bos.yuranan@gmail.com",
                                 "email_to" : connectionweb[0].Admin_Email_Contact_To,
                                 "subject" : "OTP Quota : "+connectionweb[0].Customer_Name+" ใกล้ครบจำนวน วันที่ "+str,
                                 "message" : "เรียน ผู้ดูแลระบบ"+connectionweb[0].Customer_Name+"<p>"+connectionweb[0].Web_Database_Project_Id+" ใช้งาน OTP Quota ใกล้ครบจำนวน คงเหลือในระบบจำนวน : "+connectionweb[0].Otp_Remaining_Notification
                                 +" วันที่ "+str+"</p>"
                             },{
                                  headers: {
                              "Authorization":authenticateUser(connectionweb[0].Web_Api_Username,connectionweb[0].Web_Api_Password),
                              }
                              })
                              .then(resp=>{
                                var urlsendotp =connectionweb[0].Otp_Sms_Provider_Endpoint+connectionweb[0].Otp_Sms_Provider_Api_Otp_Send;
                                    const res =  axios.post(urlsendotp,{"project_key":connectionweb[0].Otp_Sms_Provider_Project_Key,
                                              "phone":objsms.telephone}, {
                                              headers: {
                                      "Content-Type":"application/json",
                                      "api_key":connectionweb[0].Otp_Sms_Provider_Api_Key,
                                      "secret_key":connectionweb[0].Otp_Sms_Provider_Api_Secret,
                                    },
                                    }).then(res=>{
                                    if (res.data.code=="000") {
                                      let obj ={token:res.data.result.token,telephone:objsms.telephone,
                                        username:objsms.username,lastname:objsms.lastname,
                                        ref_code:res.data.result.ref_code,
                                        //AVCDAPNF.004  24/02/2025  Add Code for เพิ่ม field ผู้แนะนำ
                                        referalMobileNo: objsms.referalMobileNo,
                                        //C-AVCDAPNF.004  24/02/2025  Add Code for เพิ่ม field ผู้แนะนำ
                                        consent1:objsms.consent1,
                                        consent2:objsms.consent2,
                                        consent3:objsms.consent3,
                                        consent4:objsms.consent4,
                                        consent5:objsms.consent5,
                                        consent6:objsms.consent6,}
                                      window.sessionStorage.setItem("OTPSMS",JSON.stringify(obj));
                                      setsmsref(res.data.result.ref_code);
                                    console.log("resend",res);
                                    setIsOpenLoading(false);
                                    setcheckresend(false);
                                    setcheckresendtime(true);
                                    const dateTimesms = connectionweb[0].Otp_Sms_Provider_Timout * 60;
                                    setCounter(dateTimesms);
                                    }else{

                                    }}
                                    )
                                    .catch(err=> console.log(err))
                              })
                              .catch(err=> console.log(err))
                                            console.log("notiotp",notiotp);
                          }else if(otpUsage.otpRemaining <=0){
                                            setIsOpenLoading(false);
                                            popupotplimit()

                                          return ;
                          }else{
                          /*  const projectsms = window.sessionStorage.getItem("project_key");
                            let projectsmstoken= ""+projectsms;*/
                            var urlsendotp =connectionweb[0].Otp_Sms_Provider_Endpoint+connectionweb[0].Otp_Sms_Provider_Api_Otp_Send;
                                const res =  axios.post(urlsendotp,{"project_key":connectionweb[0].Otp_Sms_Provider_Project_Key,
                                          "phone":objsms.telephone}, {
                                          headers: {
                                  "Content-Type":"application/json",
                                  "api_key":connectionweb[0].Otp_Sms_Provider_Api_Key,
                                  "secret_key":connectionweb[0].Otp_Sms_Provider_Api_Secret,
                                },
                                }).then(res=>{
                                if (res.data.code=="000") {
                                  let obj ={token:res.data.result.token,telephone:objsms.telephone,
                                    username:objsms.username,lastname:objsms.lastname,
                                    ref_code:res.data.result.ref_code,
                                    //AVCDAPNF.004  24/02/2025  Add Code for เพิ่ม field ผู้แนะนำ
                                    referalMobileNo: objsms.referalMobileNo,
                                    //C-AVCDAPNF.004  24/02/2025  Add Code for เพิ่ม field ผู้แนะนำ
                                    consent1:objsms.consent1,
                                    consent2:objsms.consent2,
                                    consent3:objsms.consent3,
                                    consent4:objsms.consent4,
                                    consent5:objsms.consent5,
                                    consent6:objsms.consent6,}
                                  window.sessionStorage.setItem("OTPSMS",JSON.stringify(obj));
                                  setsmsref(res.data.result.ref_code);
                                console.log("resend",res);
                                setIsOpenLoading(false);
                                setcheckresend(false);
                                setcheckresendtime(true);
                                const dateTimesms = connectionweb[0].Otp_Sms_Provider_Timout * 60;
                                setCounter(dateTimesms);
                                }else{

                                }}
                                )
                                .catch(err=> console.log(err))
                          }
                }
                //if (!otpUsage.error) {
                //  console.log("errrrrr");
                //  var code ="First Name must have a value in OTP Usage: Entry No.=11. It cannot be zero or empty.";
                //    setmessageRemaining(code);
                //  popupotpRemaining()
                //  e.preventDefault();

                //    return ;
                //  }




              })
              .catch(error => console.log('error', error));



    }// resend otp

    function authenticateUser(user:string, password:string)
    {
        var token = user + ":" + password;
        var hash = btoa(token);
        return "Basic " + hash;
    }

  const handleClickVerify = async () => {
    setmessagesmsotp("");
    console.log("checkresend",checkresend);
   popupLoading()
    if (checkresend==false) {
        console.log("false");

    }
  //  const connectionweb = JSON.parse(""+window.sessionStorage.getItem("connection"));
    let otpsmstobc = window.sessionStorage.getItem('OTPSMS');
    let otpsmsconverttobc= ""+otpsmstobc;
    const objsmstobc = JSON.parse(otpsmsconverttobc);
    let clubcode = window.sessionStorage.getItem('Club_Code');
    let clubcodeconvert =""+clubcode;
    let linedata = window.sessionStorage.getItem('linedata');
    let linedataconvert =""+linedata;

  //  const otpsms = window.sessionStorage.getItem("OTPSMS");
    let otpsms = window.sessionStorage.getItem('OTPSMS');
    let otpsmsconvert= ""+otpsms;
    const objsms = JSON.parse(otpsmsconvert);

    if (!otpsms) {
      setmessagesmsotp("ไม่มีข้อมูลกรุณาส่งใหม่อีกครั้ง")
    }
    var urlotpVerify =connectionweb[0].Otp_Sms_Provider_Endpoint+connectionweb[0].Otp_Sms_Provider_Api_Otp_Verify;
    const otpnum =""+otp[0]+otp[1]+otp[2]+otp[3]+otp[4]+otp[5];
              const res = await axios.post(urlotpVerify,{"token":objsms.token,
        "otp_code":otpnum}, {
                  headers: {
          "Content-Type":"application/json",
          "api_key":connectionweb[0].Otp_Sms_Provider_Api_Key,
          "secret_key":connectionweb[0].Otp_Sms_Provider_Api_Secret,
      },
                }).then(res=> {
                  console.log(res);
                if (res.data.code=="000") {
                if (res.data.result.status==true) {
                  //checked data member bc
                  //check mobileNo
                  /*if (objsms.telephone) {
                    console.log("objsms.telephone",objsms.telephone);*/

                    var urlLicense =connectionweb[0].BC_Api_Endpoint+connectionweb[0].BC_Api_Get_Member+"?$filter=mobileNo eq '"+objsms.telephone+"' and memberClub eq '"+checkcluburl(clubcodeconvert)+"'";

                /*  }else{
                    var urlLicense =connectionweb[0].BC_Api_Endpoint+connectionweb[0].BC_Api_Get_Member+"?$filter=lineUserId eq '"+linedataconvert+"' and memberClub eq '"+clubcodeconvert+"'";
                  }*/
                //  var urlLicense =connectionweb[0].BC_Api_Endpoint+connectionweb[0].BC_Api_Get_Member+"?$filter=lineUserId eq '"+linedataconvert+"' and memberClub eq '"+clubcodeconvert+"'";

                  console.log("urlLicense",urlLicense);

                  var myHeaders = new Headers();
                  myHeaders.append("Authorization", authenticateUser(connectionweb[0].BC_Api_Username,connectionweb[0].BC_Api_Password));
                //  myHeaders.append("Content-Type", "application/json");

                  fetch(urlLicense, {
                    method: 'GET',
                    headers: myHeaders,
                    redirect: 'follow'
                  })
                .then(response => response.text())
                .then(data => {
                  const databc = JSON.parse(data);
                  if (databc.value[0]!=null) {
                    var dateObj = new Date();
                    var month = dateObj.getUTCMonth() + 1; //months from 1-12
                    var day = dateObj.getUTCDate();
                    var year = dateObj.getUTCFullYear();
                    var newdate = year + "-" + month + "-" + day;
                    //send save data firebase
                    const datatotfirebase ={
                      "address":  "",
                      "address2": "",
                      "bc_account_no": databc.value[0].memberAccountNo,
                      "club_code": clubcodeconvert,
                      "consent1": (objsmstobc.consent1==true)?(objsmstobc.consent1)?true:false:(objsmstobc.consent1==false)?false:"",
                      "consent1_date":(String(objsmstobc.consent1)==="")?"0001-01-01":newdate,
                      "consent2": (objsmstobc.consent2==true)?(objsmstobc.consent2)?true:false:(objsmstobc.consent2==false)?false:"",
                      "consent2_date":(String(objsmstobc.consent2)==="")?"0001-01-01":newdate,
                      "consent3": (objsmstobc.consent3==true)?(objsmstobc.consent3)?true:false:(objsmstobc.consent3==false)?false:"",
                      "consent3_date": (String(objsmstobc.consent3)==="")?"0001-01-01":newdate,
                      "consent4": (objsmstobc.consent4==true)?(objsmstobc.consent4)?true:false:(objsmstobc.consent4==false)?false:"",
                      "consent4_date":(String(objsmstobc.consent4)==="")?"0001-01-01":newdate,
                      "consent5": (objsmstobc.consent5==true)?(objsmstobc.consent5)?true:false:(objsmstobc.consent5==false)?false:"",
                      "consent5_date": (String(objsmstobc.consent5)==="")?"0001-01-01":newdate,
                      "consent6": (objsmstobc.consent6==true)?(objsmstobc.consent6)?true:false:(objsmstobc.consent6==false)?false:"",
                      "consent6_date": (String(objsmstobc.consent6)==="")?"0001-01-01":newdate,
                      "country": "",
                      "date_of_birth": "",
                      "email_address": "",
                      "first_name": objsmstobc.username,
                      "id_card_no": "",
                      "last_name": objsmstobc.lastname,
                      "line_user_id":  linedataconvert,
                      "mobile_phone_no": objsmstobc.telephone,
                      "post_code": "",
                      //AVCDAPNF.005  25/02/2025  Add Code for เพิ่ม field expires date และ expires point
                      "nearlyExpireDate": databc.value[0].nearlyExpireDate,
                      "nearlyExpirePoint": databc.value[0].nearlyExpirePoint,
                      //C-AVCDAPNF.005  25/02/2025  Add Code for เพิ่ม field expires date และ expires point
                      "scheme": "",
                      "sex": "",
                      //AVCDAPNF.005  25/02/2025  Add Code for อัพเดท remaining point
                      // "ramianing_point":"0",
                      "ramianing_point": databc.value[0].totalRemainingPoints,
                      //C-AVCDAPNF.005  25/02/2025  Add Code for อัพเดท remaining point
                      "systemModifiedAt":"",
                      "confirmdata":false,
                      "checkTamp":false,
                                };
                                console.log("datatotfirebase confirm",datatotfirebase);
                                // save FireBase
                              /*  const idfirebase=clubcodeconvert+"_"+linedataconvert;
                                const userDoc = doc(db, "Member",idfirebase);
                                   const newFields =  datatotfirebase;
                                    updateDoc(userDoc,newFields );*/
                                     const idfirebase=clubcodeconvert+"_"+linedataconvert;
                                    const docRef = doc(db, "Member", idfirebase );
                                     const newFields =  datatotfirebase;
                                    setDoc(docRef, newFields) .then(() =>
                                    { console.log("Document has been added successfully"); })
                                    .catch(error => { console.log(error); })
                                    sessionStorage.setItem("Customerdata", JSON.stringify(datatotfirebase));
                                    setIsOpenLoading(false);
                                    navigate('/confirmdata');

                                      // save FireBase
                  /*  var urlcreate =connectionweb[0].Web_Api_Endpoint+connectionweb[0].Web_Api_Create_Update_Web_Member_Data;
                    const resp =  axios.post(urlcreate,datatotfirebase,{
                         headers: {
                     "Authorization":authenticateUser(connectionweb[0].Web_Api_Username,connectionweb[0].Web_Api_Password),
                     }
                     })
                     .then(resp=>{
                      console.log("creat firebase",resp);
                      setIsOpenLoading(false);
                      navigate('/confirmdata');
                     })
                     .catch(err=> console.log(err))*/
                     //send save data firebase


                  }else{
                    //send save data bc
                    let otpsmstobc = window.sessionStorage.getItem('OTPSMS');
                    let otpsmsconverttobc= ""+otpsmstobc;
                    const objsmstobc = JSON.parse(otpsmsconverttobc);
                    var urlotpUsage =connectionweb[0].BC_Api_Endpoint+connectionweb[0].BC_Api_Create_Update_Member;

                    var myHeadersotpUsage = new Headers();
                    myHeadersotpUsage.append("Authorization", authenticateUser(connectionweb[0].BC_Api_Username,connectionweb[0].BC_Api_Password));
                    myHeadersotpUsage.append("Content-Type", "application/json");
                    var dateObj = new Date();
                    var month = dateObj.getUTCMonth() + 1; //months from 1-12
                    var day = dateObj.getUTCDate();
                    var year = dateObj.getUTCFullYear();
                    var newdate = year + "-" + month + "-" + day;
                    var raw = JSON.stringify({
                                  "memberAccountNo": "",
                                  "clubCode": clubcodeconvert,//*
                                  "schemeCode": "",
                                  "mobileNo":  objsmstobc.telephone,//*
                                  "lineUserId": linedataconvert, //*
                                  "firstName": objsmstobc.username,//*
                                  "lastName": objsmstobc.lastname,//*
                                  "dateOfBirth": "0001-01-01",
                                  "sex": "",
                                  "citizenID": "",
                                  //AVCDAPNF.004  24/02/2025  Add Code for เพิ่ม field ผู้แนะนำ
                                  referalMobileNo: objsmstobc.referalMobileNo,
                                  //C-AVCDAPNF.004  24/02/2025  Add Code for เพิ่ม field ผู้แนะนำ
                                  "emailAddress": "",
                                  "address1": "",
                                  "address2": "",
                                  "city": "",
                                  "county": "",
                                  "postCode": "",
                                  "consent1": (objsmstobc.consent1==true)?(objsmstobc.consent1)?"Yes":"No":(objsmstobc.consent1==false)?"No":"",
                                  "dateConsent1": (String(objsmstobc.consent1)==="")?"0001-01-01":newdate,
                                  "consent2": (objsmstobc.consent2==true)?(objsmstobc.consent2)?"Yes":"No":(objsmstobc.consent2==false)?"No":"",
                                  "dateConsent2": (String(objsmstobc.consent2)==="")?"0001-01-01":newdate,
                                  "consent3": (objsmstobc.consent3==true)?(objsmstobc.consent3)?"Yes":"No":(objsmstobc.consent3==false)?"No":"",
                                  "dateConsent3": (String(objsmstobc.consent3)==="")?"0001-01-01":newdate,
                                  "consent4": (objsmstobc.consent4==true)?(objsmstobc.consent4)?"Yes":"No":(objsmstobc.consent4==false)?"No":"",
                                  "dateConsent4": (String(objsmstobc.consent4)==="")?"0001-01-01":newdate,
                                  "consent5": (objsmstobc.consent5==true)?(objsmstobc.consent5)?"Yes":"No":(objsmstobc.consent5==false)?"No":"",
                                  "dateConsent5": (String(objsmstobc.consent5)==="")?"0001-01-01":newdate,
                                  "consent6": (objsmstobc.consent6==true)?(objsmstobc.consent6)?"Yes":"No":(objsmstobc.consent6==false)?"No":"",
                                  "dateConsent6": (String(objsmstobc.consent6)==="")?"0001-01-01":newdate,
                                  "apiStoreRegister": "",
                                  "blocked": false,//*
                                  "dateBlocked": "0001-01-01",
                                  "apiType": "CREATE"
                                  });
                                  console.log("rawbc",raw);

                            fetch(urlotpUsage, {
                              method: 'POST',
                              headers: myHeadersotpUsage,
                              body: raw,
                              redirect: 'follow'
                            })
                            .then(response => response.text())
                            .then(data => {
                              console.log("data",data);
                              const createdata = JSON.parse(data);
                              console.log(createdata);
                              if (!createdata.mobileNo) {

                                return ;
                              }
                              if (createdata.mobileNo) {

                                var urlLicense =connectionweb[0].BC_Api_Endpoint+connectionweb[0].BC_Api_Get_Member+"?$filter=mobileNo eq '"+objsms.telephone+"' and memberClub eq '"+checkcluburl(clubcodeconvert)+"'";
                                var myHeaders = new Headers();
                                myHeaders.append("Authorization", authenticateUser(connectionweb[0].BC_Api_Username,connectionweb[0].BC_Api_Password));
                              //  myHeaders.append("Content-Type", "application/json");

                                fetch(urlLicense, {
                                  method: 'GET',
                                  headers: myHeaders,
                                  redirect: 'follow'
                                })
                              .then(response => response.text())
                              .then(databc => {


                                const createdatabc = JSON.parse(databc);
                                //send save data firebase
                                const datatotfirebase ={
                                  "address":  (createdata.address==undefined)?"":createdata.address,
                                  "address2": (createdata.address2==undefined)?"":createdata.address2,
                                  "bc_account_no": createdatabc.value[0].memberAccountNo,
                                  "club_code": createdata.clubCode,
                                  "consent1": (createdata.consent1=="Yes")?(createdata.consent1)?true:false:(createdata.consent1=="No")?false:"",
                                  "consent1_date":createdata.dateConsent1,
                                  "consent2": (createdata.consent2=="Yes")?(createdata.consent2)?true:false:(createdata.consent2=="No")?false:"",
                                  "consent2_date": createdata.dateConsent2,
                                  "consent3": (createdata.consent3=="Yes")?(createdata.consent3)?true:false:(createdata.consent3=="No")?false:"",
                                  "consent3_date": createdata.dateConsent3,
                                  "consent4": (createdata.consent4=="Yes")?(createdata.consent4)?true:false:(createdata.consent4=="No")?false:"",
                                  "consent4_date": createdata.dateConsent4,
                                  "consent5": (createdata.consent5=="Yes")?(createdata.consent5)?true:false:(createdata.consent5=="No")?false:"",
                                  "consent5_date": createdata.dateConsent5,
                                  "consent6": (createdata.consent6=="Yes")?(createdata.consent6)?true:false:(createdata.consent6=="No")?false:"",
                                  "consent6_date": createdata.dateConsent5,
                                  "country": createdata.county,
                                  "city": createdata.city,
                                  "date_of_birth": createdata.dateOfBirth,
                                  "email_address": createdata.emailAddress,
                                  "first_name": createdata.firstName,
                                  "id_card_no": createdata.citizenID,
                                  "last_name": createdata.lastName,
                                  //AVCDAPNF.005  25/02/2025  Add Code for เพิ่ม field expires date และ expires point
                                  "nearlyExpireDate": createdatabc.value[0].nearlyExpireDate,
                                  "nearlyExpirePoint": createdatabc.value[0].nearlyExpirePoint,
                                  //C-AVCDAPNF.005  25/02/2025  Add Code for เพิ่ม field expires date และ expires point
                                  "line_user_id":  createdata.lineUserId,
                                  "mobile_phone_no": createdata.mobileNo,
                                  "post_code": createdata.postCode,
                                  "scheme": (createdatabc.value[0].memberScheme==undefined)?"":createdatabc.value[0].memberScheme,
                                  "scheme_code": (createdatabc.value[0].memberScheme==undefined)?"":createdatabc.value[0].memberScheme,
                                  "sex": createdata.sex,
                                  //AVCDAPNF.006  25/02/2025  Add Code for อัพเดท remaining point
                                  // "ramianing_point":"0",
                                  "ramianing_point": createdatabc.value[0].totalRemainingPoints,
                                  //C-AVCDAPNF.006  25/02/2025  Add Code for อัพเดท remaining point
                                  "systemModifiedAt":"",
                                  "confirmdata":true,
                                  "checkTamp":false,
                                            };

                                            console.log("datatotfirebase rawbc",datatotfirebase);
                                            // save FireBase
                                          /*  const idfirebase=createdata.clubCode+"_"+createdata.lineUserId;
                                            const userDoc = doc(db, "Member",idfirebase);
                                               const newFields =  datatotfirebase;
                                                updateDoc(userDoc,newFields );*/
                                               const idfirebase=createdata.clubCode+"_"+createdata.lineUserId;
                                               const docRef = doc(db, "Member", idfirebase );
                                                const newFields =  datatotfirebase;
                                               setDoc(docRef, newFields) .then(() =>
                                               { console.log("Document has been added successfully"); })
                                               .catch(error => { console.log(error); })
                                                window.sessionStorage.setItem("Confirmdata","No");
                                                setIsOpenLoading(false);
                                                  sessionStorage.setItem("Customerdata", JSON.stringify(datatotfirebase));
                                                setTimeout(() => {

                                                 //navigate('/login');
                                                 //AVCDAPNF.002  24/02/2025  Add Code for เปลี่ยนให้ nevigate ไป homepage
                                                 //  navigate('/createMember');
                                                navigate('/homepage')
                                                //C-AVCDAPNF.002  24/02/2025  Add Code for เปลี่ยนให้ nevigate ไป homepage
                                                 console.log("null");
                                                  }, 2000);

                                                  // save FireBase
                                /*var urlcreate =connectionweb[0].Web_Api_Endpoint+connectionweb[0].Web_Api_Create_Update_Web_Member_Data;
                                const resp =  axios.post(urlcreate,datatotfirebase,{
                                     headers: {
                                 "Authorization":authenticateUser(connectionweb[0].Web_Api_Username,connectionweb[0].Web_Api_Password),
                                 }
                                 })
                                 .then(resp=>{
                                  console.log("creat firebase",resp);
                                  window.sessionStorage.setItem("Confirmdata","No");
                                  setIsOpenLoading(false);
                                  setTimeout(() => {
                                   navigate('/login');
                                   console.log("null");
                                    }, 2000);

                                 })
                                 .catch(err=> console.log(err))*/
                                 //send save data firebase
                              })
                              .catch(error => {
                                console.log(error)

                                var rawbc = {
                                              "memberAccountNo": "",
                                              "clubCode": clubcodeconvert,//*
                                              "schemeCode": "",
                                              "mobileNo":  objsmstobc.telephone,//*
                                              "lineUserId": linedataconvert, //*
                                              "firstName": objsmstobc.username,//*
                                              "lastName": objsmstobc.lastname,//*
                                              "dateOfBirth": "0001-01-01",
                                              "sex": "",
                                              "citizenID": "",
                                              "emailAddress": "",
                                              "address1": "",
                                              "address2": "",
                                              "city": "",
                                              "county": "",
                                              "postCode": "",
                                              //AVCDAPNF.004  24/02/2025  Add Code for เพิ่ม field ผู้แนะนำ
                                              referalMobileNo: objsmstobc.referalMobileNo,
                                              //C-AVCDAPNF.004  24/02/2025  Add Code for เพิ่ม field ผู้แนะนำ
                                              "consent1": (objsmstobc.consent1==true)?(objsmstobc.consent1)?"Yes":"No":(objsmstobc.consent1==false)?"No":"",
                                              "dateConsent1": (String(objsmstobc.consent1)==="")?"0001-01-01":newdate,
                                              "consent2": (objsmstobc.consent2==true)?(objsmstobc.consent2)?"Yes":"No":(objsmstobc.consent2==false)?"No":"",
                                              "dateConsent2": (String(objsmstobc.consent2)==="")?"0001-01-01":newdate,
                                              "consent3": (objsmstobc.consent3==true)?(objsmstobc.consent3)?"Yes":"No":(objsmstobc.consent3==false)?"No":"",
                                              "dateConsent3": (String(objsmstobc.consent3)==="")?"0001-01-01":newdate,
                                              "consent4": (objsmstobc.consent4==true)?(objsmstobc.consent4)?"Yes":"No":(objsmstobc.consent4==false)?"No":"",
                                              "dateConsent4": (String(objsmstobc.consent4)==="")?"0001-01-01":newdate,
                                              "consent5": (objsmstobc.consent5==true)?(objsmstobc.consent5)?"Yes":"No":(objsmstobc.consent5==false)?"No":"",
                                              "dateConsent5": (String(objsmstobc.consent5)==="")?"0001-01-01":newdate,
                                              "consent6": (objsmstobc.consent6==true)?(objsmstobc.consent6)?"Yes":"No":(objsmstobc.consent6==false)?"No":"",
                                              "dateConsent6": (String(objsmstobc.consent6)==="")?"0001-01-01":newdate,
                                              "apiStoreRegister": "",
                                              "blocked": false,//*
                                              "dateBlocked": "0001-01-01",
                                              "apiType": "CREATE"
                                              };
                                var urlTamp =connectionweb[0].Web_Api_Endpoint+"/CreateTamp";
                                const resp =  axios.post(urlTamp,rawbc,{
                                     headers: {
                                 "Authorization":authenticateUser(connectionweb[0].Web_Api_Username,connectionweb[0].Web_Api_Password),
                                 }
                                 })
                                 .then(resp=>{
                                  console.log("creat urlTamp",resp);
                                  //send save data firebase
                                  const datatotfirebase ={
                                    "address":  "",
                                    "address2": "",
                                    "bc_account_no": "",
                                    "club_code": clubcodeconvert,
                                    "consent1": (objsmstobc.consent1==true)?(objsmstobc.consent1)?true:false:(objsmstobc.consent1==false)?false:"",
                                    "consent1_date":(String(objsmstobc.consent1)==="")?"0001-01-01":newdate,
                                    "consent2": (objsmstobc.consent2==true)?(objsmstobc.consent2)?true:false:(objsmstobc.consent2==false)?false:"",
                                    "consent2_date": (String(objsmstobc.consent2)==="")?"0001-01-01":newdate,
                                    "consent3": (objsmstobc.consent3==true)?(objsmstobc.consent3)?true:false:(objsmstobc.consent3==false)?false:"",
                                    "consent3_date": (String(objsmstobc.consent3)==="")?"0001-01-01":newdate,
                                    "consent4": (objsmstobc.consent4==true)?(objsmstobc.consent4)?true:false:(objsmstobc.consent4==false)?false:"",
                                    "consent4_date": (String(objsmstobc.consent4)==="")?"0001-01-01":newdate,
                                    "consent5": (objsmstobc.consent5==true)?(objsmstobc.consent5)?true:false:(objsmstobc.consent5==false)?false:"",
                                    "consent5_date": (String(objsmstobc.consent5)==="")?"0001-01-01":newdate,
                                    "consent6": (objsmstobc.consent6==true)?(objsmstobc.consent6)?true:false:(objsmstobc.consent6==false)?false:"",
                                    "consent6_date": (String(objsmstobc.consent6)==="")?"0001-01-01":newdate,
                                    "country": "",
                                    "city": "",
                                    "date_of_birth": "",
                                    "email_address": "",
                                    "first_name": objsmstobc.telephone,
                                    //AVCDAPNF.005  25/02/2025  Add Code for เพิ่ม field expires date และ expires point
                                    "nearlyExpireDate": "",
                                    "nearlyExpirePoint": "",
                                    //C-AVCDAPNF.005  25/02/2025  Add Code for เพิ่ม field expires date และ expires point
                                    "id_card_no": "",
                                    "last_name": objsmstobc.lastname,
                                    "line_user_id":  linedataconvert,
                                    "mobile_phone_no": objsmstobc.telephone,
                                    "post_code": "",
                                    "scheme": "",
                                    "sex": "",
                                    "systemModifiedAt":"",
                                    "ramianing_point":"0",
                                    "confirmdata":false,
                                    "checkTamp":true,
                                              };

                                              console.log("datatotfirebase rawbc",datatotfirebase);
                                              sessionStorage.setItem("Customerdata", JSON.stringify(datatotfirebase));
                                              // save FireBase
                                            /*  const idfirebase=clubcodeconvert+"_"+linedataconvert;
                                              const userDoc = doc(db, "Member",idfirebase);
                                                 const newFields =  datatotfirebase;
                                                  updateDoc(userDoc,newFields );*/
                                                const idfirebase=clubcodeconvert+"_"+linedataconvert;
                                                  const docRef = doc(db, "Member", idfirebase );
                                                   const newFields =  datatotfirebase;
                                                  setDoc(docRef, newFields) .then(() =>
                                                  { console.log("Document has been added successfully"); })
                                                  .catch(error => { console.log(error); })
                                                  setIsOpenLoading(false);
                                                  popupNotconnectBc()

                                                    // save FireBase
                                /*  var urlcreate =connectionweb[0].Web_Api_Endpoint+connectionweb[0].Web_Api_Create_Update_Web_Member_Data;
                                  const respcustomer =  axios.post(urlcreate,datatotfirebase,{
                                       headers: {
                                   "Authorization":authenticateUser(connectionweb[0].Web_Api_Username,connectionweb[0].Web_Api_Password),
                                   }
                                   })
                                   .then(respcustomer=>{
                                     setIsOpenLoading(false);
                                     popupNotconnectBc()
                                   })
                                   .catch(err=> console.log(err))*/
                                   //send save data firebase


                                 })
                              .catch(err=> console.log(err))
                                setIsOpenLoading(false);
                                popupNotconnectBc()
                                console.log('error22', error)
                              });



                              }
                            })
                            .catch(error => {
                              console.log(error)

                              var rawbc = {
                                            "memberAccountNo": "",
                                            "clubCode": clubcodeconvert,//*
                                            "schemeCode": "",
                                            "mobileNo":  objsmstobc.telephone,//*
                                            "lineUserId": linedataconvert, //*
                                            "firstName": objsmstobc.username,//*
                                            "lastName": objsmstobc.lastname,//*
                                            "dateOfBirth": "0001-01-01",
                                            "sex": "",
                                            "citizenID": "",
                                            "emailAddress": "",
                                            "address1": "",
                                            "address2": "",
                                            //AVCDAPNF.004  24/02/2025  Add Code for เพิ่ม field ผู้แนะนำ
                                            referalMobileNo: objsmstobc.referalMobileNo,
                                            //C-AVCDAPNF.004  24/02/2025  Add Code for เพิ่ม field ผู้แนะนำ
                                            "city": "",
                                            "county": "",
                                            "postCode": "",
                                            "consent1": (objsmstobc.consent1==true)?(objsmstobc.consent1)?"Yes":"No":(objsmstobc.consent1==false)?"No":"",
                                            "dateConsent1": (String(objsmstobc.consent1)==="")?"0001-01-01":newdate,
                                            "consent2": (objsmstobc.consent2==true)?(objsmstobc.consent2)?"Yes":"No":(objsmstobc.consent2==false)?"No":"",
                                            "dateConsent2": (String(objsmstobc.consent2)==="")?"0001-01-01":newdate,
                                            "consent3": (objsmstobc.consent3==true)?(objsmstobc.consent3)?"Yes":"No":(objsmstobc.consent3==false)?"No":"",
                                            "dateConsent3": (String(objsmstobc.consent3)==="")?"0001-01-01":newdate,
                                            "consent4": (objsmstobc.consent4==true)?(objsmstobc.consent4)?"Yes":"No":(objsmstobc.consent4==false)?"No":"",
                                            "dateConsent4": (String(objsmstobc.consent4)==="")?"0001-01-01":newdate,
                                            "consent5": (objsmstobc.consent5==true)?(objsmstobc.consent5)?"Yes":"No":(objsmstobc.consent5==false)?"No":"",
                                            "dateConsent5": (String(objsmstobc.consent5)==="")?"0001-01-01":newdate,
                                            "consent6": (objsmstobc.consent6==true)?(objsmstobc.consent6)?"Yes":"No":(objsmstobc.consent6==false)?"No":"",
                                            "dateConsent6": (String(objsmstobc.consent6)==="")?"0001-01-01":newdate,
                                            "apiStoreRegister": "",
                                            "blocked": false,//*
                                            "dateBlocked": "0001-01-01",
                                            "apiType": "CREATE"
                                            };
                              var urlTamp =connectionweb[0].Web_Api_Endpoint+"/CreateTamp";
                              const resp =  axios.post(urlTamp,rawbc,{
                                   headers: {
                               "Authorization":authenticateUser(connectionweb[0].Web_Api_Username,connectionweb[0].Web_Api_Password),
                               }
                               })
                               .then(resp=>{
                                console.log("creat urlTamp",resp);
                                //send save data firebase
                                const datatotfirebase ={
                                  "address":  "",
                                  "address2": "",
                                  "bc_account_no": "",
                                  "club_code": clubcodeconvert,
                                  "consent1": (objsmstobc.consent1==true)?(objsmstobc.consent1)?true:false:(objsmstobc.consent1==false)?false:"",
                                  "consent1_date":(String(objsmstobc.consent1)==="")?"0001-01-01":newdate,
                                  "consent2": (objsmstobc.consent2==true)?(objsmstobc.consent2)?true:false:(objsmstobc.consent2==false)?false:"",
                                  "consent2_date": (String(objsmstobc.consent2)==="")?"0001-01-01":newdate,
                                  "consent3": (objsmstobc.consent3==true)?(objsmstobc.consent3)?true:false:(objsmstobc.consent3==false)?false:"",
                                  "consent3_date": (String(objsmstobc.consent3)==="")?"0001-01-01":newdate,
                                  "consent4": (objsmstobc.consent4==true)?(objsmstobc.consent4)?true:false:(objsmstobc.consent4==false)?false:"",
                                  "consent4_date": (String(objsmstobc.consent4)==="")?"0001-01-01":newdate,
                                  "consent5": (objsmstobc.consent5==true)?(objsmstobc.consent5)?true:false:(objsmstobc.consent5==false)?false:"",
                                  "consent5_date": (String(objsmstobc.consent5)==="")?"0001-01-01":newdate,
                                  "consent6": (objsmstobc.consent6==true)?(objsmstobc.consent6)?true:false:(objsmstobc.consent6==false)?false:"",
                                  "consent6_date": (String(objsmstobc.consent6)==="")?"0001-01-01":newdate,
                                  "country": "",
                                  "city": "",
                                  "date_of_birth": "",
                                  "email_address": "",
                                  "first_name": objsmstobc.telephone,
                                  "id_card_no": "",
                                  "last_name": objsmstobc.lastname,
                                  "line_user_id":  linedataconvert,
                                  "mobile_phone_no": objsmstobc.telephone,
                                  "post_code": "",
                                  "scheme": "",
                                  //AVCDAPNF.005  25/02/2025  Add Code for เพิ่ม field expires date และ expires point
                                  "nearlyExpireDate": "",
                                  "nearlyExpirePoint": "",
                                  //C-AVCDAPNF.005  25/02/2025  Add Code for เพิ่ม field expires date และ expires point
                                  "sex": "",
                                  "systemModifiedAt":"",
                                  "ramianing_point":"0",
                                  "confirmdata":false,
                                  "checkTamp":true,
                                            };

                                            console.log("datatotfirebase rawbc",datatotfirebase);
                                            sessionStorage.setItem("Customerdata", JSON.stringify(datatotfirebase));
                                            // save FireBase
                                          /*  const idfirebase=clubcodeconvert+"_"+linedataconvert;
                                            const userDoc = doc(db, "Member",idfirebase);
                                               const newFields =  datatotfirebase;
                                                updateDoc(userDoc,newFields );*/
                                              const idfirebase=clubcodeconvert+"_"+linedataconvert;
                                                const docRef = doc(db, "Member", idfirebase );
                                                 const newFields =  datatotfirebase;
                                                setDoc(docRef, newFields) .then(() =>
                                                { console.log("Document has been added successfully"); })
                                                .catch(error => { console.log(error); })
                                                setIsOpenLoading(false);
                                                popupNotconnectBc()

                                                  // save FireBase
                              /*  var urlcreate =connectionweb[0].Web_Api_Endpoint+connectionweb[0].Web_Api_Create_Update_Web_Member_Data;
                                const respcustomer =  axios.post(urlcreate,datatotfirebase,{
                                     headers: {
                                 "Authorization":authenticateUser(connectionweb[0].Web_Api_Username,connectionweb[0].Web_Api_Password),
                                 }
                                 })
                                 .then(respcustomer=>{
                                   setIsOpenLoading(false);
                                   popupNotconnectBc()
                                 })
                                 .catch(err=> console.log(err))*/
                                 //send save data firebase


                               })
                               .catch(err=> console.log(err))
                            });
                            //send save data bc

                  }

                })
                .catch(error => {
                  setIsOpenLoading(false);
                  popupNotconnectBc()
                  console.log('error', error)
                });
                // checked data member bc

                        /*  setTimeout(() => {
                              navigate('/confirmdata');
                          }, 2000);*/

                  }else{
                    setIsOpenLoading(false);
                    //setmessagesmsotp(res.data.detail)
                    setmessagesmsotp("รหัส OTP ไม่ถูกต้อง")
                  }
                }else if(res.data.code=="100") {
                  setIsOpenLoading(false);
                  setmessagesmsotp("กรุณาระบุ OTP")
                }else if(res.data.code=="101") {
                  setIsOpenLoading(false);
                  setmessagesmsotp("ส่งออกไม่ได้ ไม่พบเบอร์โทรศัพท์")
                }else if(res.data.code=="107") {
                  setIsOpenLoading(false);
                  setmessagesmsotp("เบอร์ไม่ถูกต้อง")
                }else if(res.data.code=="1002") {
                  setIsOpenLoading(false);
                  setmessagesmsotp("Token ไม่ถูกต้อง")
                }else if(res.data.code=="5000") {
                  setIsOpenLoading(false);
                  setmessagesmsotp("ไม่สามารถระบุ OTP ได้ เนื่องจาก OTP Expire กรุณากดส่ง OTP อีกครั้ง")
                }
                else{
                  console.log("res",res.data.detail);
                  setIsOpenLoading(false);
                  setmessagesmsotp(res.data.detail)
                  console.log("sms fail");

                }
                })
                  .catch(err=> console.log(err))
      }



      const [otp, setOtp] = useState(new Array(6).fill(""));

      const handleChange = (element: any, index: any) => {


      if (isNaN(element.value)) return false;


      if (element.value.length< 2) {
        setOtp([...otp.map((d, idx) => (idx === index ? element.value : d))]);
      }else{
      }

      //Focus next input
      if (element.nextSibling) {
          element.nextSibling.focus();
      }
  };
//const  handlechange = ({target: {value}}) => this.setState(state => value.length <= 1 && !isNaN(Number(value)) && {value} || state)
let stylesweb = JSON.parse(""+window.sessionStorage.getItem('stylesetup'));

const styles = {
  title_style: {
    "backgroundColor": stylesweb.title_style.background_color,
    "border": stylesweb.title_style.border,
    "border-color": stylesweb.title_style.border_color,
    "border-radius":stylesweb.title_style.border_radius,
    "color": stylesweb.title_style.font_color,
    "font-family": stylesweb.title_style.font_name,
    "font-size": stylesweb.title_style.font_size,
    "font-weight": stylesweb.title_style.font_weight,
  },
  title2_style: {
    "backgroundColor": stylesweb.title2_style.background_color,
    "border": stylesweb.title2_style.border,
    "border-color": stylesweb.title2_style.border_color,
    "border-radius":stylesweb.title2_style.border_radius,
    "color": stylesweb.title2_style.font_color,
    "font-family": stylesweb.title2_style.font_name,
    "font-size": stylesweb.title2_style.font_size,
    "font-weight": stylesweb.title2_style.font_weight,
  },
  caption_style: {
    "backgroundColor": stylesweb.caption_style.background_color,
    "border": stylesweb.caption_style.border,
    "border-color": stylesweb.caption_style.border_color,
    "border-radius":stylesweb.caption_style.border_radius,
    "color": stylesweb.caption_style.font_color,
    "font-family": stylesweb.caption_style.font_name,
    "font-size": stylesweb.caption_style.font_size,
    "font-weight": stylesweb.caption_style.font_weight,
  },
  input_data_style: {
    "backgroundColor": stylesweb.input_data_style.background_color,
    "border": stylesweb.input_data_style.border,
    "border-color": stylesweb.input_data_style.border_color,
    "border-radius":stylesweb.input_data_style.border_radius,
    "color": stylesweb.input_data_style.font_color,
    "font-family": stylesweb.input_data_style.font_name,
    "font-size": stylesweb.input_data_style.font_size,
    "font-weight": stylesweb.input_data_style.font_weight,
  },
  title_consent_style: {
    "backgroundColor": stylesweb.title_consent_style.background_color,
    "border": stylesweb.title_consent_style.border,
    "border-color": stylesweb.title_consent_style.border_color,
    "border-radius":stylesweb.title_consent_style.border_radius,
    "color": stylesweb.title_consent_style.font_color,
    "font-family": stylesweb.title_consent_style.font_name,
    "font-size": stylesweb.title_consent_style.font_size,
    "font-weight": stylesweb.title_consent_style.font_weight,
  },
  description_consent_style: {
    "backgroundColor": stylesweb.description_consent_style.background_color,
    "border": stylesweb.description_consent_style.border,
    "border-color": stylesweb.description_consent_style.border_color,
    "border-radius":stylesweb.description_consent_style.border_radius,
    "color": stylesweb.description_consent_style.font_color,
    "font-family": stylesweb.description_consent_style.font_name,
    "font-size": stylesweb.description_consent_style.font_size,
    "font-weight": stylesweb.description_consent_style.font_weight,
  },
  consent_page_style_body: {
    "backgroundColor": stylesweb.consent_page_style.background_color,
    "border": stylesweb.consent_page_style.border,
    "border-color": stylesweb.consent_page_style.border_color,
    "color": stylesweb.consent_page_style.font_color,
    "font-family": stylesweb.consent_page_style.font_name,
    "font-size": stylesweb.consent_page_style.font_size,
    "font-weight": stylesweb.consent_page_style.font_weight,
  },
  consent_page_style_header: {
    "backgroundColor": stylesweb.consent_page_style.background_color,
    "border": stylesweb.consent_page_style.border,
    "border-color": stylesweb.consent_page_style.border_color,
    "border-top-left-radius": stylesweb.consent_page_style.border_radius,
    "border-top-right-radius": stylesweb.consent_page_style.border_radius,
    "color": stylesweb.consent_page_style.font_color,
    "font-family": stylesweb.consent_page_style.font_name,
    "font-size": stylesweb.consent_page_style.font_size,
    "font-weight": stylesweb.consent_page_style.font_weight,
  },
  consent_page_style_footer: {
    "backgroundColor": stylesweb.consent_page_style.background_color,
    "border": stylesweb.consent_page_style.border,
    "border-color": stylesweb.consent_page_style.border_color,
    "border-bottom-left-radius": stylesweb.consent_page_style.border_radius,
    "border-bottom-right-radius": stylesweb.consent_page_style.border_radius,
    "color": stylesweb.consent_page_style.font_color,
    "font-family": stylesweb.consent_page_style.font_name,
    "font-size": stylesweb.consent_page_style.font_size,
    "font-weight": stylesweb.consent_page_style.font_weight,
  },

  error_message_box_style: {
    "backgroundColor": stylesweb.error_message_box_style.background_color,
    "border": stylesweb.error_message_box_style.border,
    "border-color": stylesweb.error_message_box_style.border_color,
    "border-radius": stylesweb.error_message_box_style.border_radius,
    "color": stylesweb.error_message_box_style.font_color,
    "font-family": stylesweb.error_message_box_style.font_name,
    "font-size": stylesweb.error_message_box_style.font_size,
    "font-weight": stylesweb.error_message_box_style.font_weight,
  },
  foreground_Style: {
    "backgroundColor": stylesweb.foreground_Style.background_color,
    "border": stylesweb.foreground_Style.border,
    "border-color": stylesweb.foreground_Style.border_color,
    "border-radius": stylesweb.foreground_Style.border_radius,
    "color": stylesweb.foreground_Style.font_color,
    "font-family": stylesweb.foreground_Style.font_name,
    "font-size": stylesweb.foreground_Style.font_size,
    "font-weight": stylesweb.foreground_Style.font_weight,
  },
  background_Style: {
    "backgroundColor": stylesweb.background_Style.background_color,
    "border": stylesweb.background_Style.border,
    "border-color": stylesweb.background_Style.border_color,
    "border-radius": stylesweb.background_Style.border_radius,
    "color": stylesweb.background_Style.font_color,
    "font-family": stylesweb.background_Style.font_name,
    "font-size": stylesweb.background_Style.font_size,
    "font-weight": stylesweb.background_Style.font_weight,
  },
  //AVCDAPNF.007 04/03/2025 Add code for เพิ่ม style
  confirm_button_style: {
    backgroundColor: stylesweb.confirm_button_style.background_color,
    border: stylesweb.confirm_button_style.border,
    'border-color': stylesweb.confirm_button_style.border_color,
    'border-radius': stylesweb.confirm_button_style.border_radius,
    color: stylesweb.confirm_button_style.font_color,
    'font-family': stylesweb.confirm_button_style.font_name,
    'font-size': stylesweb.confirm_button_style.font_size,
    'font-weight': stylesweb.confirm_button_style.font_weight,
  },
  //C-AVCDAPNF.007 04/03/2025 Add code for เพิ่ม style


};



  	return (


      <div className='card'>
      {/* begin::Form */}

      <div className='row mb-8 imagelogo' style={styles.background_Style}>
      <img src={logoImageweb} alt="metronic"/>
      </div>
        <form className='form d-flex flex-center'   >
          <div className='card-body mw-800px py-20 card-body-editemember' style={styles.foreground_Style}>
            <div className='row mb-8'>
            <label className='card-label text-center mb-1 col-form-label editemember-header-label' style={styles.title_style}>ยืนยันรหัส OTP</label>
            </div>
            <div className='row mb-8'>
            <label className='card-label  mb-1 col-form-label  text-center 'style={styles.title2_style}>กรุณาระบุรหัส OTP ที่ได้รับของหมายเลข
            </label>
            <label className='card-label  mb-1 col-form-label text-center'style={styles.title2_style}>{smsphone}
            </label>
            <label className='card-label  mb-1 col-form-label  text-center countdowntime'style={styles.title2_style}>
            <div className="otp-code">
            รหัสอ้างอิง : {smsref}
            </div>

            <CountdownTimer targetDate={countdateTime} />
            </label>

            </div>


              {/* begin::Form row */}

                <div className="otp-number-send">
              {otp.map((data1, index) => {
                     return (
                         <input
                             className="digi-otp form-control form-control-sm"
                              type="number"
                              maxLength={3}
                             name="otp"
                             key={index}
                             value={data1}
                             onChange={e => handleChange(e.target, index)}
                             onFocus={e => e.target.select()}
                         />
                     );
                 })}
                 </div>
          {/* end::Form row */}
            {/* begin::Form row */}
            <div className='row'>
              <p className='text-center  messages-error'style={styles.title2_style} >{messagesmsotp}</p>
              <div className='col-lg-9'>
                <button type='reset'  onClick={() => handleClickVerify() } className='btnmember editemember btn btn-primary fw-bolder px-6 py-3 me-3'
                  //AVCDAPNF.007 04/03/2025 Add code for เพิ่ม style
                  style={styles.confirm_button_style}
                  //C-AVCDAPNF.007 04/03/2025 Add code for เพิ่ม style
                  >
                ยืนยัน
                </button>

              </div>
            </div>
            {/* end::Form row */}
            <div className='otp-again'>
              <label className='col-lg-3 col-form-label lable-otp-again'
              //AVCDAPNF.007 04/03/2025 Add code for เพิ่ม style
              style={styles.title2_style}
              //C-AVCDAPNF.007 04/03/2025 Add code for เพิ่ม style
              >ไม่ได้รับรหัส OTP</label>
              <div className='block-otp-again'>
                <button type='reset'   onClick={() => handleClickResend() } id="btnotp-again"  className={checkresendtime==true?'btnotp-again  btn btn-primary fw-bolder px-6 py-3 me-3 disabled':'btnotp-again  btn btn-primary fw-bolder px-6 py-3 me-3'}
                  //AVCDAPNF.007 04/03/2025 Add code for เพิ่ม style
                  style={styles.title2_style}
                  //C-AVCDAPNF.007 04/03/2025 Add code for เพิ่ม style
                  >
                ส่ง OTP อีกครั้ง
                </button>

              </div>
            </div>
            {/* end::Form row */}

          </div>
        </form>
        {/* end::Form */}
        {isOpenotpRemaining && <Popup
          content={<>
              <div className="box" style={styles.error_message_box_style}>
            <img src={failedlogo} alt="failedlogo" className="img-correct"/>
            <p>ระบบไม่สามารถใช้งานได้ในขณะนี้
            กรุณาทำรายการภายหลังอีกครั้ง
            ขออภัยในความไม่สะดวก
            Error Code : 002
            </p>

        </div>
          </>}
          handleClose={togglePopupotpRemaining}
        />}
        {isOpenNotconnectBc && <Popup
          content={<>
              <div className="box" style={styles.error_message_box_style}>
            <img src={failedlogo} alt="failedlogo" className="img-correct"/>
            <p>ระบบไม่สามารถใช้งานได้ในขณะนี้
                กรุณาทำรายการภายหลังอีกครั้ง
                ขออภัยในความไม่สะดวก
                Error Code : 003
                </p>

        </div>
          </>}
          handleClose={togglePopupNotconnectBc}
        />}
        {isOpenLoading && <Popup
          content={<>
              <div className="box" style={styles.error_message_box_style}>
              <h2>Loading....</h2>
              <img src={loadingicon} alt="success" className="img-correct loading-icon"/>


        </div>
          </>}

        />}



      </div>
  	)
}
